<template>
    <div class="experience-schedule">
		<ModalHeader :title="getString('reservation_schedule')" :button-text="getString('save')" @click-button="saveSchedule" />
        <AppList :items="experienceItems">
            <template v-slot:experience-schedule>
                <div class="experience-schedule-week">
                    <div class="mini-card">
                        <div class="card-header">
                            <AppButton :text="getString('exceptions')" outline @click="exceptionsActive = true" />
                        </div>
                        <div class="card-body">
                            <ExperienceTimeslotWeekday v-for="weekDay in [0, 1, 2, 3, 4, 5, 6]" :weekday="weekDay" :timeslots="scheduledTimeslots(weekDay)" @copy="copyTimeslots(weekDay)" @delete="id => removeTimeslot(id)" @add="addTimeslot" />
                        </div>
                    </div>
                </div>
            </template>
        </AppList>
		<AppBottomSheet :forceWidth="bottomSheetWidthLarge" :active="exceptionsActive" @toggling-popup="toggleBottomSheetExceptions">
			<div class="info-container" v-if="exceptionsActive">
				<ExperienceCalendar :experience-id="experienceId" @close="exceptionsActive = false" />
			</div>
		</AppBottomSheet>
    </div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import {useExperiencesStore, useUserStore} from "@/console-new/stores";
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import AppButton from "@/shared/components/AppButton.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import ExperienceInfo from "@/console-new/components/plugins/reservations/ExperienceInfo.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import ExperienceCalendar from "@/console-new/components/plugins/reservations/ExperienceCalendar.vue";
import ExperienceTimeslotEdit from "@/console-new/components/plugins/reservations/ExperienceTimeslotEdit.vue";
import ExperienceTimeslotWeekday from "@/console-new/components/plugins/reservations/ExperienceTimeslotWeekday.vue";
import API from "@/shared/helpers/API";

export default {
    setup() {
        const experiencesStore = useExperiencesStore();
        const userStore = useUserStore();
        const languageStore = useLanguageStore();
        const svgStore = useSvgStore();
        return {getString: languageStore.getString, readableEurValue: languageStore.readableEurValue, experiencesStore, userStore, svgStore};
    },
    name: "ExperienceSchedule",
    components: {
		ExperienceTimeslotWeekday,
		ExperienceCalendar, AppTextInput, ExperienceInfo, ModalHeader, AppBottomSheet, AppButton, AppList, ExperienceTimeslotEdit},
	mixins: [WindowWidth],
	props: {
		experienceId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			exceptionsActive: false,
		}
	},
    computed: {
		experience() {
			return this.experiencesStore.businessExperiences.find(experience => experience.experience_id === this.experienceId);
		},
        experienceItems() {
            return [
                {
                    title: this.getString('days_in_advance'),
                    explain: this.getString('days_in_advance_explain'),
                    numberInput: true,
                    min: 0,
                    max: 365,
					value: this.experience.days_advance,
					callbackNumber: (v) => { this.experience.days_advance = v; }
                },
                {
                    title: '',
                    customSlot: 'experience-schedule',
                }
            ]
        },
		bottomSheetWidthLarge() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else if(this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1280px";
			}
		},
    },
    methods: {
		scheduledTimeslots(weekDay) {
			let result = [];
			this.experience.timeslots.forEach(slot => {
				if(slot.weekday === weekDay) {
					result.push(slot);
				}
			});
			return result;
		},
		copyTimeslots(weekDay) {

			this.experience.timeslots = this.experience.timeslots.filter(slot => slot.weekday === weekDay);
			this.experience.timeslots.forEach(timeslot => {
				for(let i = 0; i < 7; i++) {
					if (i !== weekDay) {
						let copiedTimeslot = JSON.parse(JSON.stringify(timeslot));
						copiedTimeslot.experience_timeslot_id = "new"+Math.random();
						copiedTimeslot.weekday = i;
						this.experience.timeslots.push(copiedTimeslot);
					}
				}
			});

		},
		removeTimeslot(id) {
			this.experience.timeslots = this.experience.timeslots.filter(slot => slot.experience_timeslot_id !== id);
		},
		addTimeslot(newTimeslot) {
			this.experience.timeslots.push(newTimeslot);
		},
		toggleBottomSheetExceptions(open) {
			if(!open) {
				this.exceptionsActive = false;
			}
		},
		saveSchedule() {
			this.experiencesStore.saveExperienceSchedule(this.experienceId, this.experience.timeslots, (r) => {

			});
		}
    },
	mounted() {

		API.init().getExperienceSchedule(this.userStore.currBusinessId, this.experienceId, r => {
			this.experience.timeslots = r.timeslots.map(t => {
				return this.experiencesStore.normalizeTimeslot(t);
			});
		});

	}
}
</script>

<style scoped lang="scss">
.experience-schedule-week {
    width: 100%;

    .mini-card {
        display: flex;
        flex-direction: column;
        width: 100%;
        box-shadow: 0 2px 2px $alpha;
        border-radius: 13px;

        .card-header {
            background-color: var(--color-bg-primary-2);
            padding: 10px;
            border-radius: 13px 13px 0 0;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

        .card-body {
            width: 100%;
            display: flex;
            flex-direction: column;
			background-color: var(--color-bg);
			border-radius: 0 0 13px 13px;

        }
    }
}
</style>